import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Affix.st.css';
import InputConsumer from '../InputConsumer';

const Affix = ({
  children,
  value,
}: {
  children?: React.ReactNode;
  value?: string;
}) => (
  <InputConsumer consumerCompName={Affix.displayName}>
    {({ size, inPrefix, inSuffix, border, disabled, onInputClicked }) => (
      <div
        className={st(classes.root, {
          size,
          inPrefix,
          inSuffix,
          border,
          disabled,
        })}
        onClick={onInputClicked}
        data-hook="custom-affix"
      >
        {value || children}
      </div>
    )}
  </InputConsumer>
);

Affix.displayName = 'Input.Affix';
Affix.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
};

export default Affix;
